import React, { useState } from 'react';
import Icons from 'components/atoms/Icons';
import { OnQueryInputChangeType } from 'components/types/FilterTypes';
import Axios from 'axios';
import { getSearchWidget } from 'lib/util';

type FiltersSearchBarProps = {
  placeholder: string;
  setFilterSearchResults: Function;
  setSearchType: Function;
  entity: string;
  source: string;
};

const FiltersSearchBar = (props: FiltersSearchBarProps) => {
  const [queryInputValue, setQueryInputValue] = useState('');

  const { placeholder, setFilterSearchResults, entity, source, setSearchType } =
    props;

  let defaultSearchBody: any = {
    content: {},
    limit: 100,
  };

  const onQueryInputChange: OnQueryInputChangeType = (value: string) => {
    setQueryInputValue(value);
  };

  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onQueryInputChange(newValue);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      search();
    }
  };

  const search = async () => {
    defaultSearchBody.query = {
      keyphrase: queryInputValue,
    };
    try {
      const searchReq = {
        widget: {
          items: [
            {
              rfk_id: getSearchWidget(),
              entity: entity,
              sources: [source],
              search: defaultSearchBody,
            },
          ],
        },
      };
      const response = await Axios.post('/api/discovery', searchReq);

      const data = response.data.widgets[0].content;
      if (data && data.length > 0) {
        setFilterSearchResults(data);
        setSearchType(entity);
      } else {
        setFilterSearchResults([]);
      }
    } catch (error) {
      console.log(`error:${error}`);
    }
  };

  return (
    <div className="search-input search-text-box">
      <div
        className={'search-icon-wrapper'}
        onClick={() => {
          search();
        }}
      >
        <Icons id="pld-green-search" className="icon-search" />
      </div>
      <div className="input-icon-container">
        <input
          autoFocus={true}
          placeholder={placeholder}
          value={queryInputValue}
          onChange={onChange}
          onKeyDown={onKeyDown}
          type="text"
        />

        {queryInputValue && (
          <div
            className="close-button"
            onClick={() => {
              setQueryInputValue('');
              setFilterSearchResults(null);
            }}
          >
            <Icons id="close" className="icon icon-close" aria-hidden="true" />
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltersSearchBar;
